import React from 'react';

const Context = React.createContext({});

export default Context;

export const Provider = Context.Provider;

export const withContext = Component => props => {
    return (
        <Context.Consumer>
            {context => <Component {...props} context={context} />}
        </Context.Consumer>
    );
};